export const invoicesQueuedValues = {
	all: 'all',
	some: 'some',
	none: 'none'
};

export const invoicesQueuedOptions = [
	{
		text: 'All',
		value: invoicesQueuedValues.all,
		disabled: false
	},
	{
		text: 'Some',
		value: invoicesQueuedValues.some,
		disabled: true
	},
	{
		text: 'None',
		value: invoicesQueuedValues.none,
		disabled: false
	}
];
